import type { SVGProps } from "react";
// generated from ArrowUp.svg — do not edit manually
// prettier-ignore
export default function ArrowUp(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 19 11 L 12 4 M 12 4 L 5 11 M 12 4 V 20" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
